const LayoutDefault = () =>
  import(/* webpackChunkName: "kp-penjualan" */ '@/layouts/LayoutDefault.vue');
const Dashboard = () =>
  import(/* webpackChunkName: "kp-penjualan" */ '@/views/pelayanan/Index.vue');
// Transaksi Penjualan
const TransaksiPenjualan = () =>
  import(
    /* webpackChunkName: "kp-penjualan" */ '@/views/pelayanan/penjualan/transaksi/Index.vue'
  );
const TambahTransaksiPenjualan = () =>
  import(
    /* webpackChunkName: "kp-penjualan" */ '@/views/pelayanan/penjualan/transaksi/Tambah.vue'
  );
const RestockPbs = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/pelayanan/penjualan/restock-pbs/Index.vue'
  );

const LayoutData = () =>
  import(/* webpackChunkName: "kp-penjualan" */ '@/layouts/LayoutData.vue');
const CekFaktur = () =>
  import(
    /* webpackChunkName: "admin" */ '@/views/CekFaktur.vue'
  );
const KirimBarangPromoKeSc = () =>
  import(
    /* webpackChunkName: "kp-penjualan" */ '@/views/pelayanan/penjualan/kirim-barang-promo/barang-ke-sc/Index.vue'
  );
const TambahKirimBarangPromoKeSc = () =>
  import(
    /* webpackChunkName: "kp-penjualan" */ '@/views/pelayanan/penjualan/kirim-barang-promo/barang-ke-sc/Tambah.vue'
  );
const KirimBarangPromoKeStockist = () =>
  import(
    /* webpackChunkName: "kp-penjualan" */ '@/views/pelayanan/penjualan/kirim-barang-promo/barang-ke-stockist/Index.vue'
  );
const TambahKirimBarangPromoKeStockist = () =>
  import(
    /* webpackChunkName: "kp-penjualan" */ '@/views/pelayanan/penjualan/kirim-barang-promo/barang-ke-stockist/Tambah.vue'
  );

let root = '/penjualan';

export default [
  {
    path: root + '/',
    component: Dashboard,
    meta: {
      auth: true,
      title: 'Dashboard | Kantor Pelayanan',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/cek-faktur',
    component: CekFaktur,
    meta: {
      auth: true,
      title: 'Cek Faktur',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/transaksi-penjualan/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Transaksi Penjualan',
    },
    children: [
      {
        path: '',
        name: 'penjualan',
        component: TransaksiPenjualan,
        meta: {
          auth: true,
          title: 'Transaksi Penjualan | Penjualan KP',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-transaksi-penjualan',
        name: 'penjualan.tambah',
        component: TambahTransaksiPenjualan,
        meta: {
          auth: true,
          title: 'Tambah Transaksi Penjualan | Penjualan KP',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Transaksi Penjualan',
        },
      },
      {
        path: ':id',
        name: 'penjualan.edit',
        component: TambahTransaksiPenjualan,
        meta: {
          auth: true,
          title: 'Edit Transaksi Penjualan | Penjualan KP',
          layout: LayoutDefault,
        },
      },
    ],
  },
  {
    path: root + '/restock-pbs/',
    component: RestockPbs,
    meta: {
      auth: true,
      title: 'Restock P3S | Penjualan KP',
      layout: LayoutDefault,
      breadcrumb: 'Restock P3S',
    }
  },
  {
    path: root + '/kirim-barang-promo/barang-ke-sc',
    component: LayoutData,
    meta: {
      breadcrumb: 'Kirim Barang Promo',
    },
    children: [
      {
        path: '',
        component: KirimBarangPromoKeSc,
        name: 'penjualan.kirim-barang-promo.ke-sc',
        meta: {
          auth: true,
          title: 'Kirim Barang Promo ke SC | Penjualan KP',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Barang Promo ke SC',
        },
      },
      {
        path: 'tambah',
        component: TambahKirimBarangPromoKeSc,
        name: 'penjualan.kirim-barang-promo.ke-sc.tambah',
        meta: {
          auth: true,
          title: 'Kirim Barang Promo ke SC | Penjualan KP',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Barang Promo ke SC',
        },
      },
    ]
  },
  {
    path: root + '/kirim-promo/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Kirim Promo',
    },
    children: [
      {
        path: 'tambahan-sc',
        component: KirimBarangPromoKeSc,
        name: 'penjualan.kirim-barang-promo.ke-sc',
        meta: {
          auth: true,
          title: 'Tambahan Barang Promo di Luar Promo ke SC | Penjualan KP',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Promo',
        },
      },
      {
        path: 'tambahan-sc/tambah',
        component: TambahKirimBarangPromoKeSc,
        name: 'penjualan.kirim-barang-promo.ke-sc.tambah',
        meta: {
          auth: true,
          title: 'Kirim Tambahan Barang Promo ke SC | Penjualan KP',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Tambahan Barang Promo ke SC',
        },
      },
      {
        path: 'tambahan-stockist',
        component: KirimBarangPromoKeStockist,
        name: 'penjualan.kirim-barang-promo.ke-stockist',
        meta: {
          auth: true,
          title: 'Tambahan Barang Promo di Luar Promo ke Stockist | Penjualan KP',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Promo',
        },
      },
      {
        path: 'tambahan-stockist/tambah',
        component: TambahKirimBarangPromoKeStockist,
        name: 'penjualan.kirim-barang-promo.ke-stockist.tambah',
        meta: {
          auth: true,
          title: 'Kirim Tambahan Barang Promo ke Stockist | Penjualan KP',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Tambahan Barang Promo ke Stockist',
        },
      },
    ]
  },
];
